import { Component } from '@angular/core';

@Component({
  selector: 'app-home-about',
  standalone: true,
  imports: [],
  templateUrl: './home-about.component.html',
  styleUrl: './home-about.component.scss'
})
export class HomeAboutComponent {

}
